import { forEach, join, sortBy } from 'lodash-es';
import moment from 'moment';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import MainButtonSet from '../../components/mainButtonSet';
import OrderStatusBgColor from '../../components/orderStatusBgColor';
import OrderStatusColors from '../../components/orderStatusColors';
import Pager from '../../components/pager';
import StageHeader from '../../components/stageHeader';
import TmsDatepicker from '../../components/tmsDatepicker';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import UnisProductModal from '../../components/unisProductModal';
import WaitingButton from '../../components/waiting-button/waiting-button.vue';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import switchBillingToService from '../../shared/switchBillingToService';
import { analytics } from '../../services/analytics';
import template from './trackShipmentLoggedIn.vue';

import trackingGuest from '../trackingGuest';
@Component({
    mixins: [template],
    components: {
        Datepicker,
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
        Pager,
        TmsDatepicker,
        OrderStatusColors,
        OrderStatusBgColor,
        WaitingButton,
        trackingGuest,
    },
})
export default class TrackShipmentLoggedIn extends Vue {
    searshInfo: any = {};
    searchBy: Array<any> = ['PRO', 'BOL', 'PU'];
    originCountry: Array<any> = ['PRO', 'BOL', 'PU'];
    recentlyTrackedShipments: Array<any> = [];
    setsessionTrackedShipment: any = {};
    sessionTrackedShipments: Array<any> = [];
    showErrTip: boolean = false;
    errorText: String = '';
    isSearch: boolean = false;
    paging: any = {};
    billto_id: any = '';
    inputError: any = '';
    isopenItem: Array<any> = [];
    trackingGuestOrderId: any = '';

    trackShipmentQuerymodle: any = '2';

    @Watch('searshInfo.search_text', { deep: true })
    getSearchInfo(val: any, oldVal: any) {
        this.replaceUrl(val);
    }

    private async getCustomerData() {
        await switchBillingToService
            .post()
            .then((res: any) => {
                if (res.data.billing != undefined && res.data.billing.location_id) {
                    this.billto_id = res.data.billing.location_id;
                } else {
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }

    async mounted() {
        await this.getCustomerData();
        if (this.$route.query && this.$route.query.searchText) {
            this.searshInfo.search_text = this.$route.query.searchText;
            this.trackShipment(1);
        }
    }

    goToLogoIn() {
        window.location.href = '#/';
    }

    onSortby(sortby: any) {
        this.sessionTrackedShipments = sortBy(this.sessionTrackedShipments, [sortby]);
    }

    onChickTrackedShipment(trackedShipment: any) {
        this.setsessionTrackedShipment = trackedShipment;
    }

    private routerPush(item: any = null) {
        this.trackingGuestOrderId = this.setsessionTrackedShipment.order_id;
    }

    private trackShipment(page: any) {
        if (!this.billto_id) return;
        if (
            this.searshInfo.from_date ||
            this.searshInfo.to_date ||
            this.searshInfo.zipcode ||
            this.searshInfo.search_text
        ) {
            this.isSearch = true;
            const searchType = String(
                this.searshInfo.search_type || 'shipment_reference'
            ).toLowerCase();
            const shouldTrackSearch = !page || Number(page) <= 1;
            let searchInfo = '';

            if (this.searshInfo.search_text)
                searchInfo = `${searchInfo}search_text=${this.searshInfo.search_text}&`;
            if (this.searshInfo.search_type)
                searchInfo = `${searchInfo}search_type=${this.searshInfo.search_type}&`;
            if (this.searshInfo.from_date)
                searchInfo = `${searchInfo}from_date=${this.searshInfo.from_date}&`;
            if (this.searshInfo.to_date)
                searchInfo = `${searchInfo}to_date=${this.searshInfo.to_date}&`;
            if (this.paging.per_page)
                searchInfo = `${searchInfo}page_size=${this.paging.per_page}&`;
            if (this.searshInfo.country)
                searchInfo = `${searchInfo}country=${this.searshInfo.country}&`;
            if (this.searshInfo.zipcode)
                searchInfo = `${searchInfo}zipcode=${this.searshInfo.zipcode}&`;
            searchInfo = `${searchInfo}billto_id=${this.billto_id}&`;
            searchInfo = `${searchInfo}&page=${page}`;
            tmsServiceBackend.get(`/cpv2/tracking/loginGetOrders?${searchInfo}`).then(
                (res: any) => {
                    if (res.data.status == 0) {
                        if (shouldTrackSearch) {
                            analytics.trackSearch({
                                searchType,
                                success: false,
                                resultCount: 0,
                                hasSearchTerm: Boolean(this.searshInfo.search_text),
                            });
                        }
                        this.showErrorFun(res.data.message);
                        this.sessionTrackedShipments = [];
                        this.isSearch = false;
                        this.$forceUpdate();
                        return;
                    }
                    this.paging = res.data.data;
                    this.sessionTrackedShipments = res.data.data.data;
                    if (shouldTrackSearch) {
                        analytics.trackSearch({
                            searchType,
                            success: true,
                            resultCount: this.sessionTrackedShipments.length,
                            hasSearchTerm: Boolean(this.searshInfo.search_text),
                        });
                    }
                    forEach(this.sessionTrackedShipments, (trackedShipment: any) => {
                        if (trackedShipment.d_date2) {
                            let yer = moment(trackedShipment.d_date2).format('YYYY');
                            let time = moment(trackedShipment.d_date2).format('LLLL');
                            let timeArray = time.split(',');
                            trackedShipment['scheduledDelivery'] =
                                join(timeArray.slice(0, 2), ',') + ',' + yer;
                        }
                        this.getProgressImage(
                            trackedShipment,
                            trackedShipment.stage,
                            trackedShipment.status
                        );
                    });
                    if (this.sessionTrackedShipments.length == 1) {
                        this.trackingGuestOrderId = this.sessionTrackedShipments[0].order_id;
                    }
                    if (this.sessionTrackedShipments.length > 0)
                        forEach(this.sessionTrackedShipments, (shipments: any) => {
                            if (shipments.pictures && shipments.pictures.length > 0)
                                forEach(shipments.pictures, (item: any) => {
                                    if (item.file_category_name == 'CONF_RATE')
                                        this.$set(item, 'fileName', 'LOA');
                                    if (item.file_category_name == 'INSP_CERT')
                                        this.$set(item, 'fileName', 'W&I');
                                });
                        });

                    this.isSearch = false;
                },
                (err: any) => {
                    if (shouldTrackSearch) {
                        analytics.trackSearch({
                            searchType,
                            success: false,
                            resultCount: 0,
                            hasSearchTerm: Boolean(this.searshInfo.search_text),
                        });
                    }
                    this.isSearch = false;
                    this.showErrorFun(err.response.data.statusText);
                }
            );
        } else {
            if (!page || Number(page) <= 1) {
                analytics.trackSearch({
                    searchType: 'shipment_reference',
                    success: false,
                    resultCount: 0,
                    hasSearchTerm: false,
                });
            }
            this.showErrorFun('Please enter shipment reference or date or postcode.');
            return;
        }
    }

    private getProgressImage(trackedShipment: any, shipmentStage: any, shipmentStatus: any) {
        if (shipmentStatus == 4 && shipmentStage == 5) {
            // Invoiced
            trackedShipment.deliveryStages = 5;
        } else if (shipmentStage == 5 && shipmentStatus > 0) {
            // Delivered
            trackedShipment.deliveryStages = 4;
        } else if (shipmentStage == 4 && shipmentStatus > 0) {
            // Out for Delivery
            trackedShipment.deliveryStages = 3;
        } else if (shipmentStage == 1 || shipmentStage == 2 || shipmentStage == 3) {
            // Picked Up
            trackedShipment.deliveryStages = 2;
        } else if (shipmentStage == 0 && shipmentStatus > 1) {
            // In Process
            trackedShipment.deliveryStages = 2;
        } else if (shipmentStage == 0 && shipmentStatus == 1) {
            // Order created
            trackedShipment.deliveryStages = 1;
        } else {
            // Empty
        }

        this.$forceUpdate();
    }

    onSessionTrackedShipment(item: any) {
        this.setsessionTrackedShipment = item;
        this.routerPush(item);
    }

    onSubmit(scope: any) {
        this.$validator.validateAll(scope).then(res => {
            if (res) {
                if (this.searshInfo.search_text) this.replaceUrl(this.searshInfo.search_text);
                this.trackShipment(1);
            }
        });
    }

    triggerSearchFromPager(item: any) {
        this.paging.per_page = item.pageSize;
        this.trackShipment(item.currentPage);
    }

    chargeTrack(searchInfo: any) {
        this.trackingGuestOrderId = '';
        this.searshInfo.search_text = searchInfo;
        this.replaceUrl(searchInfo);
        this.trackShipment(1);
    }

    replaceUrl(searchInfo: any) {
        let currentUrl: any = window.location.href;
        if (currentUrl.includes('searchText=') && searchInfo) {
            currentUrl = currentUrl.replace(/searchText=[^&]+/, `searchText=${searchInfo}`);
        } else {
            if (currentUrl.includes('?')) {
                if (searchInfo) currentUrl += `&searchText=${searchInfo}`;
            } else {
                if (searchInfo) currentUrl += `?searchText=${searchInfo}`;
            }
        }
        window.history.replaceState(null, '', currentUrl);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/trackShipmentLoggedIn/index.ts